import React, { useState } from "react";
import { auth, provider } from "../firebase/firebaseConfig";
import {
  signInWithEmailAndPassword,
  signInWithPopup
} from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion"; // Added for that smooth entry

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (error) {
      alert(error.message);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, provider);
      navigate("/dashboard");
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div style={container}>
      {/* LEFT PANEL - Futuristic HUD */}
      <motion.div 
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        style={leftPanel}
      >
        <motion.div
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 4, repeat: Infinity }}
        >
          <h1 style={logoTitle}>GD SYSTEM <span style={{fontSize: '30px'}}>🎤</span></h1>
          <p style={logoSub}>Next-Gen AI Evaluation Hub</p>
        </motion.div>
        
        <div style={statusDotContainer}>
          <div style={pulseDot}></div>
          <span style={{fontSize: '12px', opacity: 0.7}}>AI ENGINE: ONLINE</span>
        </div>
      </motion.div>

      {/* RIGHT PANEL - Neo-Glassmorphism Login */}
      <div style={rightPanel}>
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          whileHover={interactiveHover} // The Interactive Blue Reflection!
          style={card}
        >
          <h2 style={{ marginBottom: "5px", fontSize: '24px' }}>Welcome Back 👋</h2>
          <p style={{ color: "#94a3b8", fontSize: '14px', marginBottom: '20px' }}>
            Identify yourself to access the platform.
          </p>

          <div style={inputGroup}>
            <label style={label}>Email Address</label>
            <input
              type="email"
              placeholder="name@example.com"
              style={input}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div style={inputGroup}>
            <label style={label}>Secure Password</label>
            <input
              type="password"
              placeholder="••••••••"
              style={input}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <motion.button 
            whileHover={{ scale: 1.02, boxShadow: '0 0 15px rgba(79, 70, 229, 0.4)' }}
            whileTap={{ scale: 0.98 }}
            style={loginBtn} 
            onClick={handleLogin}
          >
            Authenticate 🚀
          </motion.button>

          <div style={divider}>
            <span style={line}></span>
            <span style={{padding: '0 10px'}}>OR SECURE ACCESS</span>
            <span style={line}></span>
          </div>

          <motion.button 
            whileHover={{ backgroundColor: '#f1f5f9', color: '#000' }}
            style={googleBtn} 
            onClick={handleGoogleLogin}
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/layout/google.svg" alt="G" style={{width: '18px', marginRight: '10px'}} />
            Continue with Google
          </motion.button>

          <p style={{ marginTop: "20px", fontSize: "14px", textAlign: 'center', color: '#94a3b8' }}>
            New to the System?{" "}
            <Link to="/register" style={{ color: "#6366f1", fontWeight: 'bold', textDecoration: 'none' }}>
              Create Account
            </Link>
          </p>
        </motion.div>
      </div>
    </div>
  );
}

/* 🎨 THEME STYLES */

const container = {
  display: "flex",
  height: "100vh",
  background: "#050505", // OLED Black
  backgroundImage: "radial-gradient(circle at 50% -20%, #1e1b4b, #050505)", // Midnight Indigo Glow
  fontFamily: "'Inter', sans-serif",
  color: "white",
  overflow: 'hidden'
};

const leftPanel = {
  flex: 1.2,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: 'relative'
};

const logoTitle = {
  fontSize: "60px",
  fontWeight: "900",
  letterSpacing: "-2px",
  margin: 0,
  background: "linear-gradient(to right, #6366f1, #a855f7)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
};

const logoSub = {
  marginTop: "10px",
  fontSize: "18px",
  opacity: 0.6,
  letterSpacing: "2px",
  textAlign: 'center'
};

const rightPanel = {
  flex: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const card = {
  background: "rgba(30, 41, 59, 0.4)", // Frosted Glass
  backdropFilter: "blur(12px)",
  padding: "40px",
  borderRadius: "24px",
  width: "380px",
  border: "1px solid rgba(255, 255, 255, 0.05)",
  display: "flex",
  flexDirection: "column",
  transition: "0.3s ease-in-out",
};

const interactiveHover = {
  borderColor: "#6366f1",
  boxShadow: "0px 0px 30px rgba(99, 102, 241, 0.3)",
};

const inputGroup = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  marginBottom: '15px'
};

const label = {
  fontSize: '12px',
  fontWeight: 'bold',
  color: '#6366f1',
  marginLeft: '5px'
};

const input = {
  padding: "14px",
  borderRadius: "12px",
  border: "1px solid #334155",
  background: "#0f172a",
  color: "white",
  outline: "none",
  fontSize: '15px',
};

const loginBtn = {
  padding: "14px",
  background: "linear-gradient(135deg, #4f46e5, #7c3aed)",
  color: "white",
  border: "none",
  borderRadius: "12px",
  cursor: "pointer",
  fontWeight: "bold",
  fontSize: "16px",
  marginTop: "10px"
};

const googleBtn = {
  padding: "12px",
  background: "transparent",
  color: "white",
  border: "1px solid #334155",
  borderRadius: "12px",
  cursor: "pointer",
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: '500'
};

const divider = {
  display: 'flex',
  alignItems: 'center',
  textAlign: "center",
  fontSize: "11px",
  color: "#475569",
  margin: "20px 0",
  letterSpacing: '1px'
};

const line = {
  flex: 1,
  height: '1px',
  background: '#1e293b'
};

const statusDotContainer = {
  position: 'absolute',
  bottom: '40px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px'
};

const pulseDot = {
  width: '8px',
  height: '8px',
  background: '#22c55e',
  borderRadius: '50%',
  boxShadow: '0 0 10px #22c55e'
};

export default Login;